import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { BarChart3 } from "lucide-react";

const formatCurrency = (value) => {
  return "$" + formatNumber(value);
};

const formatNumber = (value, decimals = 0) => {
  if (isNaN(value) || !isFinite(value)) {
    return decimals > 0 ? (0).toFixed(decimals) : "0";
  }
  return value.toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export function ComparisonCard({ results }) {
  return (
    <Card className="shadow-md">
      <CardHeader className="p-4 sm:p-6">
        <CardTitle className="flex items-center gap-2 text-base sm:text-lg md:text-xl">
          <BarChart3 className="h-5 w-5 sm:h-6 sm:w-6 text-primary flex-shrink-0" />
          KoFlip vs Traditional Investment Comparison ({results.rentalPeriod}{" "}
          Months)
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 sm:p-6 pt-0 space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          <div className="text-center">
            <h4 className="text-sm sm:text-base md:text-lg font-medium text-gray-700 mb-3">
              Without KoFlip
            </h4>
            <div className="bg-gray-50 p-3 sm:p-4 rounded-lg">
              <p className="text-xs sm:text-sm text-gray-600 mb-2">
                Traditional 4% Annual Appreciation
              </p>
              <div className="space-y-2">
                <div className="flex justify-between text-xs sm:text-sm">
                  <span className="text-gray-600">Initial Value:</span>
                  <span className="font-medium">
                    {formatCurrency(results.presentValue)}
                  </span>
                </div>
                <div className="flex justify-between text-xs sm:text-sm">
                  <span className="text-gray-600">
                    Value After {results.rentalPeriod} Months:
                  </span>
                  <span className="font-medium">
                    {formatCurrency(results.traditionalValue)}
                  </span>
                </div>
                <div className="border-t pt-2">
                  <div className="flex justify-between text-xs sm:text-sm">
                    <span className="text-gray-600 font-medium">
                      Total Profit:
                    </span>
                    <span className="font-bold text-gray-600">
                      {formatCurrency(results.traditionalProfit)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center">
            <h4 className="text-sm sm:text-base md:text-lg font-medium text-gray-700 mb-3">
              With KoFlip
            </h4>
            <div className="bg-blue-50 p-3 sm:p-4 rounded-lg">
              <p className="text-xs sm:text-sm text-gray-600 mb-2">
                Upfront Rental (Start) + Guaranteed Return & Profit (End)
              </p>
              <div className="space-y-2">
                <div className="flex justify-between text-xs sm:text-sm">
                  <span className="text-gray-600">Upfront Rental:</span>
                  <span className="font-medium">
                    {formatCurrency(results.upfrontRental)}
                  </span>
                </div>
                <div className="flex justify-between text-xs sm:text-sm">
                  <span className="text-gray-600">Guaranteed Return:</span>
                  <span className="font-medium">
                    {formatCurrency(results.guaranteedReturn)}
                  </span>
                </div>
                <div className="flex justify-between text-xs sm:text-sm">
                  <span className="text-gray-600">Owner's Profit Share:</span>
                  <span className="font-medium">
                    {formatCurrency(results.ownerProfit)}
                  </span>
                </div>
                <div className="border-t pt-2">
                  <div className="flex justify-between text-xs sm:text-sm">
                    <span className="text-gray-600 font-medium">
                      Total Owner Profit:
                    </span>
                    <span
                      className={`font-bold ${
                        results.koflipOwnerReturn >= results.traditionalProfit
                          ? "text-green-600"
                          : "text-red-600"
                      }`}
                    >
                      {formatCurrency(results.koflipOwnerReturn)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Owner Return Timeline Comparison - hidden for now */}
      </CardContent>
    </Card>
  );
}
